import script from "./AcButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AcButton.vue?vue&type=script&lang=ts&setup=true"

import "./AcButton.vue?vue&type=style&index=0&id=5dff623f&lang=scss"

const __exports__ = script;

export default __exports__